import { cn } from '@/utils/cn';
import React from 'react';

const ModalFooter = React.forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(({ className, ...props }, ref) => {
  return <div ref={ref} className={cn('flex justify-end gap-[8px] mt-[16px]', className)} {...props} />;
});
ModalFooter.displayName = 'ModalFooter';

export { ModalFooter };
